import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Filler,
  Tooltip,
  Legend
);

const LineChart = () => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          usePointStyle: true,
          color: "black",
        },
      },
      title: {
        display: true,
        text: "Sales Report",
        align: "start",
        font: {
          size: 20,
        },
        // padding: { top: 25 },
      },
      tooltip: {
        backgroundColor: "#399E79",
        displayColors: false,
        titleFont: {
          size: 14,
          weight: "bold",
        },
        bodyFont: {
          size: 16,
        },
      },
    },
    scales: {
      x: {
        display: true,
      },
      y: {
        title: {
          text: "Sq feet",
          display: true,
        },
        grid: {
          display: false,
        },
        ticks: {
          callback: function (value) {
            if (value === 0) {
              return value;
            }
            return value / 1000 + "k";
          },
        },
      },
    },
  };

  const labels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const data = {
    labels,
    datasets: [
      {
        label: "2024",
        data: [
          8000, 22000, 38000, 58000, 36000, 30000, 20000, 18000, 28000, 36000,
          22000, 18000,
        ],
        borderColor: "rgb(238, 108, 77)",
        tension: 0.5,
        pointStyle: "circle",
        pointRadius: 4, // Adjust the point radius
        pointBackgroundColor: "rgb(238, 108, 77)",
        pointBorderColor: "rgb(238, 108, 77)",
      },
      {
        label: "2025",
        data: [
          28000, 48000, 54000, 78000, 60000, 58000, 42000, 55000, 58000, 54000,
          72000, 60000,
        ],
        borderColor: "rgb(57, 158, 121)",
        tension: 0.5,
        pointStyle: "circle",
        pointRadius: 4,
        pointBackgroundColor: "#399E79",
        pointBorderColor: "#399E79",
      },
    ],
  };

  const modifiedData = {
    ...data,
    datasets: data.datasets.map((dataset) => {
      const clonedDataset = { ...dataset };
      const lastDataIndex = dataset.data.length - 1;
      const lastDataColor = "black"; // Change this to the desired color
      clonedDataset.pointBorderColor = dataset.data.map((_, index) =>
        index === lastDataIndex ? lastDataColor : dataset.pointBorderColor
      );
      return clonedDataset;
    }),
  };

  return (
    // <div className="linechart-container shadow-md    rounded-lg bg-white">
    //   <div className="linechart ">
    //     <Line data={modifiedData} options={options} />
    //   </div>
    // </div>
    // <div className="shadow-md w-[650px]  3xl:w-[730px]  2xl:w-[700px]  custom-xl:w-[690px]  xl:w-[670px] 4xl:w-[970px]  h-full  mt-10 rounded-lg bg-white">
    // <div className="w-12/12 h-full px-6   ">

    <div className="shadow-md  h-auto 4xl:h-[590px] w-full rounded-lg bg-white">
      {/* <div className="lg:w-full  4xl:w-[1200px] 3xl:w-[1070px] 3xl:h-[610px] 3xl:pt-10  2xl:w-full xl:w-[630px] pb-5 xl:h-[360px]   px-6 xl:pl-8"> */}
    <div className=" h-full px-6   ">
      <Line data={modifiedData} options={options} />
    </div>
  </div>
  );
};

export default LineChart;
